/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".main-background[_ngcontent-%COMP%]{background:-webkit-gradient(linear,left top,left bottom,from(#a2a9b9),to(#eef3ff)) no-repeat!important;min-height:100vh}\n/*# sourceMappingURL=app.component.css.map*/"];
export { styles as styles };
